export default "__VITE_ASSET__BGHnOPe0__"